<template>
  <form
    @submit.prevent="submit"
    class="product-design-category-form uk-form-stacked"
  >
    <text-input
      :disabled="!isEditable"
      :errors="fields.errors.name"
      :label="$t('fields.name')"
      ref="name"
      v-model="fields.values.name"
    />

    <text-input
      :disabled="!isEditable"
      :errors="fields.errors.slug"
      :label="$t('fields.slug')"
      :placeholder="slugPlaceholder"
      ref="slug"
      v-model="fields.values.slug"
    />

    <attachment-input
      :disabled="!isEditable"
      :errors="fields.errors.image"
      :label="$t('fields.image')"
      attachment-type="IMAGE"
      type="number"
      v-model="fields.values.image"
    />

    <text-input
      :disabled="!isEditable"
      :errors="fields.errors.popularity"
      :label="$t('fields.popularity')"
      type="number"
      v-model.number="fields.values.popularity"
    />

    <submit-button :disabled="!isSubmittable" type="primary" />
    <cancel-button />
  </form>
</template>

<script>
import AttachmentInput from '@/components/AttachmentInput';
import CancelButton from '@/components/CancelButton';
import Form from '@/mixins/Form';
import KeywordListInput from '@/components/KeywordListInput';
import slugQuery from '@/api/queries/slug.graphql';
import SubmitButton from '@/components/SubmitButton';
import TextInput from '@/components/TextInput';
import TextListInput from '@/components/TextListInput';

export default {
  name: 'product-design-category-form',
  mixins: [
    Form({
      name: { required: true },
      slug: true,
      image: { type: Form.Types.Reference },
      popularity: { default: 0 },
    }),
  ],
  components: {
    AttachmentInput,
    CancelButton,
    KeywordListInput,
    SubmitButton,
    TextInput,
    TextListInput,
  },
  mounted() {
    this.$refs.name.focus();
  },
  apollo: {
    slugPlaceholder: {
      query: slugQuery,
      variables() {
        return { value: this.fields.values.name };
      },
      fetchPolicy: 'network-only',
      debounce: { wait: 500 },
      update({ slug }) {
        return slug;
      },
      skip() {
        return !this.fields.values.name;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductDesignCategoryForm.vue?5dc163e6